import React, { useCallback } from 'react'
import { Tag, Space } from 'antd-mobile'
import { formatJSON } from '../../utils'

const tagColor = ['danger', '#2db7f5', 'success', '#918f8f']

export default function RelateTagList({ list = [], round = true, fill = 'solid', color = '#7d94ec', wrap = true }) {
    const renderColor = useCallback((item) => {
        const { labelColor } = formatJSON(item.extendColumn) || {}
        return labelColor || color || ''
    }, [color])
    return (list && list.length > 0 &&
        (<div className='relate-tag-list' style={{ marginTop: 5 }}>
            <Space wrap={wrap} style={{ '--gap': '5px' }}>
                {list.map((item, index) => (
                    item && (
                        <Tag round={round}
                            key={index}
                            fill={fill}
                            color={renderColor(item)}>
                            {item.tagName}
                        </Tag>
                    )
                ))}
            </Space>
        </div>)
    )
}
